import { GrapevineHappeningEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineHappeningEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineHappeningEventsApi(configuration),
    [configuration]
  );
};
